/**
 * @file close-modal-button.tsx
 * @module app/components/close-modal-button
 * @description Reusable close button for modal headers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.1
 * @version 1.3.1
 */

import CrossSvg from '../../_admin/assets/media/close.svg';

interface CloseModalButtonProps {
  onClick: () => void;
  title?: string;
  className?: string;
}

const CloseModalButton = ({
  onClick,
  title = 'Close',
  className = 'uw-btn uw-btn-close-modal',
}: CloseModalButtonProps) => {
  return (
    <button
      type="button"
      aria-label={title}
      className={className}
      title={title}
      onClick={onClick}
    >
      <img src={CrossSvg} alt={title} />
    </button>
  );
};

export default CloseModalButton;